/**
 * @param {number} durationSec
 */
export function slotDurationMs(durationSec) {
  const sec = typeof durationSec === 'number' && durationSec > 0 ? durationSec : 10;
  return sec * 1000;
}
